<template>
    <div v-if="dataForm.step == '05'">
        <div class="el-message-box__wrapper fifth-step four-step" >
            <!-- <el-button size="mini" v-if="id" class="downBtn" @click="downloadDraft">下载协议草稿</el-button> -->
            <div class="el-message-box1">
                <!-- <div class="el-message-box__header">
                    <div class="el-message-box__title">
                        <span>服务协议</span>
                    </div>
                </div> -->
                <!-- <div class="" v-if="!parameUrl" >
                    <div class="el-message-box__btns">
                        <el-button type="button" @click="handlerSend"  :loading="isloading" class="el-button el-button--default el-button--small el-button--primary ">
                            <span>提交签署</span>
                        </el-button>
                        <el-button type="button" @click="handlerDowload"  :loading="isloading" class="el-button el-button--default el-button--small el-button--primary ">
                            <span>下载协议</span>
                        </el-button>
                    </div>
                    <el-tabs class="work-flow-tab" v-model="activeName" type="border-card" @tab-click="handlerTabs" >
                        <el-tab-pane label="进口协议" name="import" v-if="dataForm.bizTypes.indexOf('01') != -1">
                            <iframe id="immPreviweFile" :src="iframeImportSrc" frameborder="0" class="iframe-fifith-step" :style="{height: screenHeight - 408 + 'px'}"></iframe>
                        </el-tab-pane>
                        <el-tab-pane label="出口协议" name="out" v-if="dataForm.bizTypes.indexOf('02') != -1">
                            <iframe id="immPreviweFile" :src="iframeOutSrc" frameborder="0" class="iframe-fifith-step" :style="{height: screenHeight - 408 + 'px'}"></iframe>
                        </el-tab-pane>
                    </el-tabs>
                </div> -->
                <div :style="{height: screenHeight - 300 + 'px'}" v-loading="isloading" element-loading-text="拼命加载中....">
                    <iframe :src="parameUrl" frameborder="0" class="is-iframe"></iframe>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            id: '',
            activeName: 'import',
            isloading: false,
            iframeImportSrc: '',
            iframeOutSrc: '',
            screenHeight: '',
            downloadUrl: '',
            parameUrl: '',
            screenHeight: '',
        }
    },
    props: {
        dataForm: {
            type: Object,
            defualt: {}
        }
    },
    mounted () {
        this.screenHeight = window.screen.height
    },
    watch: {
        'dataForm.step': {
            handler (val) {
                if (val == '05' && (this.dataForm.importProtocolId || this.dataForm.exportProtocolId)) {
                    // let id = ''
                    // if (this.dataForm.importProtocolId) {
                    //     id = this.dataForm.importProtocolId
                    //     this.activeName = 'import'
                    // } else {
                    //     id = this.dataForm.exportProtocolId
                    //     this.activeName = 'out'
                    // }
                    // this.parameUrl = ''
                    // this.screenHeight = window.screen.height
                    // this.getPrintPreView(id)

                    if (this.dataForm.importProtocolId && !this.dataForm.importDone) {
                        this.activeName = 'import'
                    } else if (this.dataForm.exportProtocolId && !this.dataForm.exportDone) {
                        this.activeName = 'out'
                    } else {
                        this.$message.error('未获取到协议信息，请您联系商务！')
                    }
                    this.handlerSend()
                }
            },
            immediate: true
        }
    },
    methods: {
        downloadDraft() {
            this.$get(`/crm/client/signProtocol/print?id=${this.id}`).then(({data}) => {
                if(data && data.code === 'C0000') {
                    if(data.result) {
                        open(data.result)
                        // const a = document.createElement('a')
                        //     fetch(data.result).then(res => res.blob()).then(blob => { // 将链接地址字符内容转变成blob地址
                        //     a.href = URL.createObjectURL(blob)
                        //     a.download = '协议' // 下载文件的名字
                        //     document.body.appendChild(a)
                        //     a.click()
                        // })
                    }
                }
            })
        },
        getPrintPreView (id) {
            this.$post('/crm/client/signProtocol/printPreView', {id: id}).then(({data}) => {
                if (data && data.code == 'C0000') {
                    this.downloadUrl = data.result
                    let startIndex = data.result.indexOf('cicsc.com/') + 10
                    let iframeSrc = 'https://scp-imm.cicsc.com/?file=' + data.result.substring(startIndex) + '&v=' + new Date().getTime()
                    if (this.activeName == 'import') {
                        this.iframeImportSrc = iframeSrc
                    } else {
                        this.iframeOutSrc = iframeSrc
                    }
                   
                }
            })
        },
        handlerTabs () {
            if (this.activeName == 'import') {
                this.getPrintPreView(this.dataForm.importProtocolId)
            } else {
                this.getPrintPreView(this.dataForm.exportProtocolId)
            }
        },
        handlerSend () {
            let id = ''
            if (this.activeName == 'import') {
                id = this.dataForm.importProtocolId
            } else {
                id = this.dataForm.exportProtocolId
            }
            this.isloading = true
            this.$get('/crm/client/signProtocol/get', {id: id}).then(({data}) => {
                if (data && data.code == 'C0000') {
                    this.id = data.result.id
                    this.$post('/crm/client/signProtocol/toSign', data.result).then(({data}) => {
                        if (data && data.code == 'C0000') {
                            // this.$message({
                            //     type: "success",
                            //     message: data.message
                            // })
                            this.parameUrl = data.result
                          //  window.location.reload(true)
                        }
                    }).finally(() => {
                        this.isloading = false
                    })
                }
            })
            
        },
        handlerDowload () {
            window.open(this.downloadUrl)
        }
    }
}
</script>

<style lang="scss">
.fifth-step{
    .downBtn{
      position: absolute;
      right: 22px;
      top: 75px;
      z-index: 1;
    }
    .el-message-box1{
        width: 100% !important;
    }
    .iframe-fifith-step {
        height: 100%;
        width: 100%;
    }
    .el-message-box__btns{
        position: absolute;
        right: 10px;
        z-index: 2;
    }
    .el-message-box1 {
        padding: 0;
    }
    .is-iframe {
        width: 100%;
        height: 100%;
    }
}
</style>